module.exports = __webpack_public_path__ + "img/razzo-studio-logo.8310fb36.svg";